import { render, staticRenderFns } from "./ChooseAddress.vue?vue&type=template&id=6c4be8fe&scoped=true&"
import script from "./ChooseAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAddress.vue?vue&type=style&index=0&id=6c4be8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4be8fe",
  null
  
)

export default component.exports